<template>
  <FormContainer withoutDivider>
    <template #title>Détails du contrat</template>
    <template #content>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_88"
          :model-value="sousDispositifModel"
          label="Sous Dispositif"
          :required="meta.sousDispositif?.$status === PropertyStatus.Required"
          :alertLabel="meta.sousDispositif?.$messageErreurDirty!"
          class="col-12 col-md-12 col-sm-36"
          :items="lov.SousDispositif"
          key-id="code"
          key-label="intitule"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_88"
          v-model="natureContratModel"
          label="Nature de contrat ou d’avenant"
          :required="meta.contrat?.natureContrat?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.natureContrat?.$messageErreurDirty!"
          class="col-12 col-md-12 col-sm-36"
          :items="natureContratItems"
          key-id="id"
          key-label="label"
          :readonly
        />
        <WrapperDropdown
          id="field_unknown"
          :model-value="typeContratAvenantModel"
          label="Type de contrat ou d’avenant"
          :required="meta.contrat?.typeContratAvenant?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.typeContratAvenant?.$messageErreurDirty!"
          class="col-24 col-md-24 col-sm-36"
          :items="lov.TypeContratAvenant"
          key-id="code"
          key-label="intitule"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_89"
          v-model="emploiOccupeModel"
          label="Emploi occupé pendant le contrat (intitulé précis)"
          :required="meta.contrat?.emploiOccupe?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.emploiOccupe?.$messageErreurDirty!"
          :maxlength="200"
          deletable
          :readonly
          class="col-18 col-md-18 col-sm-36"
        />
        <WrapperInput
          id="field_unknown"
          v-model="emploinCcnModel"
          label="Classification de l'emploi dans la convention collective"
          :required="meta.contrat?.emploinCcn?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.emploinCcn?.$messageErreurDirty!"
          deletable
          :readonly
          class="col-18 col-md-18 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_90"
          v-model="niveauQualificationCcnModel"
          label="Niveau"
          :required="meta.contrat?.niveauQualificationCcn?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.niveauQualificationCcn?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :readonly
          :maxlength="15"
        />
        <WrapperInput
          id="field_91"
          v-model="coefficientCcnModel"
          label="Coefficient hiérarchique"
          :required="meta.contrat?.coefficientCcn?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.coefficientCcn?.$messageErreurDirty!"
          :maxlength="5"
          deletable
          :readonly
          class="col-18 col-md-18 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperInputNumber
          id="field_94"
          v-model="dureePeriodeEssaiJoursModel"
          label="Durée de la période d'essai (en jours calendaires)"
          :required="meta.contrat?.dureePeriodeEssaiJours?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dureePeriodeEssaiJours?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          deletable
          :readonly
          :decimal="0"
          :maxlength="3"
          :help="dureePeriodeEssaiJoursHelp"
        />
        <WrapperInputDate
          id="field_92"
          v-model="dateDebutExecutionContratModel"
          label="Date de début d'exécution du contrat"
          :required="meta.contrat?.dateDebutExecutionContrat?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateDebutExecutionContrat?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
        <WrapperInputDate
          id="field_unknown"
          v-model="dateEffetAvenantModel"
          label="Si avenant, renseignez la date d’effet"
          :required="meta.contrat?.dateEffetAvenant?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateEffetAvenant?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInputDate
          id="field_93"
          v-model="dateFinCddOuActionSiCdiModel"
          label="Date de fin du CDD ou de l'action de professionnalisation si CDI"
          :required="meta.contrat?.dateFinCddOuActionSiCdi?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateFinCddOuActionSiCdi?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
        <WrapperInputDuree
          id="field_96"
          v-model="dureeHebdomadaireModel"
          label="Durée hebdomadaire du travail"
          :required="meta.contrat?.dureeHebdomadaire?.heure?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dureeHebdomadaire?.heure?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DUREE"
          :hint="HINT_DUREE"
          deletable
          :maxlength="5"
          :readonly
        />
        <WrapperInputDate
          id="field_95"
          v-model="dateConclusionModel"
          label="Date de conclusion (signature du contrat)"
          :required="meta.contrat?.dateConclusion?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateConclusion?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
      </div>
      <div
        class="form__bloc"
        v-if="alertPlus26AnsLabel"
      >
        <BasicAlert
          v-if="alertPlus26AnsLabel"
          alertType="warning"
          :alertLabel="alertPlus26AnsLabel"
          class="col-36 col-md-36 col-sm-36"
        />
      </div>

      <div class="form__bloc">
        <WrapperInputNumber
          v-if="meta.contrat?.salaire?.montant?.$status === PropertyStatus.NotPresent"
          id="field_97"
          label="Salaire brut mensuel à l'embauche"
          hint="€ / mois"
          class="col-10 col-md-14 col-sm-36"
          :separateur="true"
          :placeholder="PLACEHOLDER_MONTANT"
          :readonly
          :maxlength="7"
          :decimal="2"
          disabled
        />
        <WrapperInputNumber
          v-else
          id="field_97"
          v-model="montantSalaireModel"
          :label="model?.typePublic === 'Interimaire' ? 'Salaire horaire brut à l\'embauche' : 'Salaire brut mensuel à l\'embauche'"
          :required="meta.contrat?.salaire?.montant?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.salaire?.montant?.$messageErreurDirty!"
          :hint="model?.typePublic === 'Interimaire' ? '€ / heure' : '€ / mois'"
          class="col-10 col-md-14 col-sm-36"
          :separateur="true"
          :placeholder="model?.typePublic === 'Interimaire' ? PLACEHOLDER_MONTANT_HORAIRE : PLACEHOLDER_MONTANT"
          :readonly
          :maxlength="7"
          :decimal="2"
        />
      </div>
      <BasicText
        v-if="meta.contrat?.salaire?.montant?.$status !== PropertyStatus.NotPresent"
        font-style="italic"
        size="body-m"
      >
        Merci de vous référer à ce
        <BasicLink
          label="lien"
          @link-click="redirectExterne('https://www.akto.fr/contrat-professionnalisation/')"
        />
        pour connaître le salaire applicable.
      </BasicText>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import type { DureeHebdomadaireDTO } from '@/features/api/extranet/dto/Demande/shared'
import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import { CPRO_ACTIONS } from '@/features/interface/demande/cpro/useDemandeCPROActions'
import {
  FormContainer,
  HINT_DATE,
  HINT_DUREE,
  PLACEHOLDER_DATE,
  PLACEHOLDER_DUREE,
  PLACEHOLDER_MONTANT,
  PLACEHOLDER_MONTANT_HORAIRE,
} from '@/features/interface/demande/shared'
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'
import { useDemandeCPROStore } from '../../../../useDemandeCPROStore'

  import { NatureContratHorsTT, NatureContratLibelle, NatureContratTTInterimaire, NatureContratTTPermanent } from '@/features/domaine/types/opco/Demande/CPRO'
import { arrayToDropdownItems } from '@/features/interface/shared/tools'
import { redirectExterne } from '@/features/shared/tools/url'
import type { DropdownItem } from '@designSystem/index'

  const store = useDemandeCPROStore()
  const { setupFieldWithKey } = store
  const { meta, lov, readonly, model, estTT } = storeToRefs(store)
  const { alertPlus26AnsLabel } = inject(CPRO_ACTIONS)!

  const sousDispositifModel = setupFieldWithKey<string>('sousDispositif', false)
  const natureContratModel = setupFieldWithKey<string>('contrat.natureContrat', false)
  const typeContratAvenantModel = setupFieldWithKey<string>('contrat.typeContratAvenant', false)
  const emploiOccupeModel = setupFieldWithKey<string>('contrat.emploiOccupe', true)
  const emploinCcnModel = setupFieldWithKey<string>('contrat.emploinCcn', true)
  const niveauQualificationCcnModel = setupFieldWithKey<string>('contrat.niveauQualificationCcn', false)
  const coefficientCcnModel = setupFieldWithKey<string>('contrat.coefficientCcn', true)
  const dureePeriodeEssaiJoursModel = setupFieldWithKey<string>('contrat.dureePeriodeEssaiJours', true)
  const dateDebutExecutionContratModel = setupFieldWithKey<string>('contrat.dateDebutExecutionContrat', true)
  const dateEffetAvenantModel = setupFieldWithKey<string>('contrat.dateEffetAvenant', true)
  const dateFinCddOuActionSiCdiModel = setupFieldWithKey<string>('contrat.dateFinCddOuActionSiCdi', true)
  const dureeHebdomadaireModel = setupFieldWithKey<DureeHebdomadaireDTO>('contrat.dureeHebdomadaire', true)
  const dateConclusionModel = setupFieldWithKey<string>('contrat.dateConclusion', true)
  const montantSalaireModel = setupFieldWithKey<string>('contrat.salaire.montant', true)
  const dureePeriodeEssaiJoursHelp = computed(() => {
    return model.value?.contrat?.natureContrat === 'Cdi'
      ? 'Si aucune période d’essai est prévue, veuillez saisir 0'
      : undefined
  })

  const natureContratItems = computed<DropdownItem<string>[]>(() => {
    if( estTT.value ){
      return (model.value?.typePublic === 'Interimaire' ) ? arrayToDropdownItems(NatureContratTTInterimaire, NatureContratLibelle) : arrayToDropdownItems(NatureContratTTPermanent, NatureContratLibelle)
    } else{
      return arrayToDropdownItems(NatureContratHorsTT, NatureContratLibelle)
    }

  })
</script>
